import { useState, type FormEvent } from 'react';
import { ApiError } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { ErrorBox, Field } from '../components/ui';

export function LoginPage() {
  const { login, loading } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<ApiError | Error | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await login(username.trim(), password);
    } catch (err) {
      if (err instanceof ApiError
          && (err.isUnauthorized || err.status === 400 || err.code === 'authentication_failed')) {
        setError(new ApiError(err.status, err.code, 'Неверное имя пользователя или пароль.'));
      } else {
        setError(err instanceof Error ? err : new Error(String(err)));
      }
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <h1>REGWAY CRM</h1>
        <div className="sub">Вход в систему сопровождения заявок</div>
        <ErrorBox error={error} />
        <Field label="Имя пользователя">
          <input value={username} onChange={(e) => setUsername(e.target.value)}
                 autoComplete="username" autoFocus required />
        </Field>
        <Field label="Пароль">
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                 autoComplete="current-password" required />
        </Field>
        <button className="btn primary" type="submit" disabled={loading || !username || !password}>
          {loading ? 'Вход…' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
